import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import usePausableDelay from "./usePausableDelay";

export default function Queue({children, initialDelay, pause}) {
    const [activeIndex, setActiveIndex] = React.useState(-1);
    const childrenWithoutNulls = React.Children.toArray(children).filter((child) => child !== null);

    const next = () => {
        setActiveIndex(activeIndex + 1);
    };
    const initializeQueue = React.useCallback(() => setActiveIndex(0), []);

    usePausableDelay({callback: initializeQueue, delay: initialDelay, pause});

    return childrenWithoutNulls.map((item, index) => {
        const isActive = !pause && activeIndex === index;
        return React.cloneElement(item, {
            isActive,
            next,
        });
    });
}

Queue.propTypes = {
    initialDelay: PropTypes.number,
    pause: PropTypes.bool,
};
Queue.defaultProps = {
    initialDelay: 2000,
    pause: false,
};

export function QueueItem({children, enabled, isActive, next, delayBeforeNext}) {
    const [isOpen, setIsOpen] = React.useState(false);
    React.useEffect(() => {
        if (!enabled && isActive) {
            next();
        } else if (enabled && isActive && !isOpen) {
            setTimeout(() => {
                setIsOpen(true);
            }, delayBeforeNext);
        }
    }, [enabled, isActive, isOpen, next, delayBeforeNext]);
    const onDismiss = () => {
        setIsOpen(false);
        next();
    };

    return children({
        onDismiss,
        isOpen,
    });
}

QueueItem.propTypes = {
    isActive: PropTypes.bool,
    next: PropTypes.func,
    enabled: PropTypes.bool,
    delayBeforeNext: PropTypes.number,
};

QueueItem.defaultProps = {
    next: noop,
    enabled: true,
    active: true,
    delayBeforeNext: 2000,
};
